import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

// Sample order data (can be dynamic in the future)
const orders = [
  {
    id: "R2510033",
    date: "January 28, 2025",
    poNumber: "BDT01282025",
    status: "Manufacturing",
    tracking: "-",
  },
];

const OrderHistory = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        Order History
      </Typography>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "none",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f7f7f5" }}>
              {["Order", "Order Date", "PO#", "Status", "Tracking"].map(
                (header) => (
                  <TableCell key={header} sx={{ color: "#1d1d1f" }}>
                    <b>{header}</b>
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((order) => (
              <TableRow key={order.id}>
                <TableCell
                  sx={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  {order.id}
                </TableCell>
                <TableCell>{order.date}</TableCell>
                <TableCell>{order.poNumber}</TableCell>
                <TableCell>{order.status}</TableCell>
                <TableCell>{order.tracking}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default OrderHistory;
